/* AFS7 - direct toevoegen vanaf de home page, plus de sticky call to action.

   Voegt altijd de EERSTE beschikbare variant toe, net als de standaardkeuze op
   de productpagina zelf, zodat er nooit iets anders in de mand belandt dan wat
   er op de kaart staat.

   Het telbolletje in de header
   ----------------------------
   "Added" op de knop is een belofte; het bolletje bij het tasje is het bewijs.
   Zonder dat laatste weet de klant niet of er echt iets gebeurd is, en dat is
   precies het moment waarop iemand afhaakt of twee keer klikt.

   We vragen daarom bij /cart/add.js meteen de HEADER-sectie mee op (Shopify's
   Section Rendering API) en zetten de verse inhoud van het winkelmandlinkje
   terug op de pagina. Zo komt de markup van het thema zelf terug: het juiste
   icoon (icon-cart in plaats van icon-cart-empty), het bolletje met het aantal
   en de verborgen tekst voor schermlezers.

   NIET zelf optellen. De EasyGift-app zet een gratis regel in de cart zodra de
   drempel gehaald wordt, dus een klik kan het aantal van 1 naar 3 brengen. Een
   teller die "plus 1" doet zou dan 2 tonen terwijl er 3 dingen in zitten.

   Lukt het hertekenen niet, dan telt een terugval via /cart.js zelf, zodat het
   aantal hoe dan ook klopt. Het sectie-id verschilt per thema en wordt uit de
   pagina afgeleid in plaats van hard gezet.

   paintCount wordt naar buiten gezet als window.afs7PaintCount, zodat
   afs7-cartfix.js hetzelfde bolletje kan bijwerken na een wijziging in de lade
   of op de cartpagina. Anders bleef de header op het oude aantal staan zodra
   iemand daar iets verwijderde, en dat is precies waar de teller voor bedoeld is.

   Tot slot roepen we 'afs7:cart-added' af. Staat de lade op deze pagina, dan
   vult en opent die zichzelf daarop. Staat hij er niet, bijvoorbeeld op de
   collectiepagina, dan luistert er niemand en verandert er niets. */
(function () {
  'use strict';
  if (window.__afs7Shop) return;
  window.__afs7Shop = true;

  function cartLink() {
    return document.querySelector('a.header__icon--cart') ||
           document.querySelector('a[href$="/cart"]');
  }

  function headerSectionId() {
    var link = cartLink();
    var sec = link && link.closest ? link.closest('[id^="shopify-section"]') : null;
    if (!sec) sec = document.querySelector('[id^="shopify-section"][id*="header"]');
    return sec ? sec.id.replace(/^shopify-section-/, '') : null;
  }

  function paintFromSection(html) {
    if (!html) return false;
    var box = document.createElement('div');
    box.innerHTML = html;
    var fresh = box.querySelector('a.header__icon--cart');
    var live = document.querySelector('a.header__icon--cart');
    if (!fresh || !live) return false;
    live.innerHTML = fresh.innerHTML;
    return true;
  }

  function paintCount(n) {
    var live = cartLink();
    if (!live) return;
    var b = live.querySelector('.cart-count-bubble');
    if (n > 0) {
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; live.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + n + '</span>' +
                    '<span class="visually-hidden">' + n + ' items</span>';
      var icon = live.querySelector('svg');
      if (icon && icon.classList.contains('icon-cart-empty')) {
        icon.classList.remove('icon-cart-empty');
        icon.classList.add('icon-cart');
      }
    } else if (b) { b.remove(); }
  }
  window.afs7PaintCount = paintCount;

  function countFallback() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () {});
  }

  function refreshCart() {
    ['cart:refresh', 'cart:build'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: {} })); } catch (e) {}
  }

  function add(btn, id, plan) {
    if (!id) return;
    var label = btn.getAttribute('data-afs7-label') || btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (plan) body.items[0].selling_plan = Number(plan);
    var sid = headerSectionId();
    if (sid) body.sections = sid;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (j) {
      var done = false;
      if (j && j.sections) {
        var keys = Object.keys(j.sections);
        for (var i = 0; i < keys.length && !done; i++) done = paintFromSection(j.sections[keys[i]]);
      }
      if (!done) countFallback();
      btn.textContent = 'Added';
      refreshCart();
      try { document.dispatchEvent(new CustomEvent('afs7:cart-added')); } catch (e) {}
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
    }).catch(function () {
      btn.textContent = 'Try again';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-afs7-add]');
    if (!btn) return;
    e.preventDefault();
    add(btn, btn.getAttribute('data-afs7-add'), btn.getAttribute('data-afs7-plan'));
  });

  /* Sticky call to action: verschijnt zodra de banner uit beeld is. */
  function bootSticky() {
    var sk = document.querySelector('[data-afs7-sticky]');
    if (!sk || sk.__boot) return;
    sk.__boot = true;
    var anchor = document.querySelector('[data-afs7-stickyanchor]') ||
                 document.querySelector('.shopify-section');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sk.classList.toggle('is-on', !en.isIntersecting); });
      }, { threshold: 0 }).observe(anchor);
    } else { sk.classList.add('is-on'); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSticky, { once: true });
  } else { bootSticky(); }
  document.addEventListener('shopify:section:load', bootSticky);
})();